export default () => {
	window.addEventListener('load', () => {
		const loadingObj = document.querySelector('.js-loading');
		loadingObj.classList.add('is-loaded');
		const deleteLoadingObj = () => {
			loadingObj.parentNode.removeChild(loadingObj);
		};
		loadingObj.addEventListener('webkitTransitionEnd', deleteLoadingObj);
		loadingObj.addEventListener('transitionEnd', deleteLoadingObj);
	});
};
